import { render, staticRenderFns } from "./ChannelDemo.vue?vue&type=template&id=1fbc1821"
import script from "./ChannelDemo.vue?vue&type=script&lang=js"
export * from "./ChannelDemo.vue?vue&type=script&lang=js"
import style0 from "./ChannelDemo.vue?vue&type=style&index=0&id=1fbc1821&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports